export const WEBLATE_COMPONENT_NAME = 'business-center/business-center-client';
export const REGISTRATION_CACHE_KEY = 'registrationToken';
export const MOBILE_PARTNER_ID = 'mobile-partner-id';
export const MOBILE_USER_EMAIL = 'mobile-user-email';
